import React from 'react';
import { PrimaryButton, SiteModal } from '../../../components/common';
import './DiscoveredDevices.scss';
import { constants } from '../../../helpers';

const ProxySessionPopup = ({ backButtonHandler, hideModalHandler, isOpen }) => {
  return (
    <SiteModal
      classes={'proxy-session-popup'}
      wrapperClass={'proxy-session-popup-wrapper'}
      modalTitle={constants.DEVICE_DASHBOARD_PROXY_POPUP_TITLE}
      showModal={isOpen}
      hideModal={hideModalHandler}
    >
      <div className="mt-4">
        <PrimaryButton
          className="btn btn-primary-outline btn-rentention"
          type="submit"
          height="56px"
          fontSize="1.125rem"
          width="100%"
          onClick={backButtonHandler}
        >
          {constants.DEVICE_DASHBOARD_PROXY_POPUP_BACK_BUTTON_LABEL}
        </PrimaryButton>
      </div>
    </SiteModal>
  );
};

export default ProxySessionPopup;
